<template>
    <div class="stepper-box custom-100">
        <b-row class="top">
            <div class="divider-line" :style="{width: `${(100/(steps.length) * (steps.length - 1)) - 10}%`}"></div>
            <div class="steps-wrapper">
                <template v-if="topButtons">
                    <div v-if="currentStep.index > 0" class="stepper-button-top previous" @click="backStep()">
                        <i class="material-icons">keyboard_arrow_left</i>
                    </div>
                </template>
                <template v-for="(step, index) in steps">
                    <div :class="['step', isStepActive(index, step)]" :key="index" :style="{width: `${100 / steps.length}%`}">
                        <div class="circle">
                            <i class="material-icons md-18">
                                {{ (step.completed) ? 'done' : step.icon }}
                            </i>
                        </div>
                        <div class="step-title">
                            <h6 style="white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;">{{step.title}}</h6>
                            <!--h7 class="step-subtitle">{{step.subtitle}}</h7-->
                        </div>
                    </div>
                </template>
                <div v-if="topButtons" :class="['stepper-button-top next', !canContinue ? 'deactivated' : '']" @click="nextStep()">
                    <i class="material-icons">keyboard_arrow_right</i>
                </div>
            </div>
        </b-row>
        <b-row class="custom-100">
        <div class="content custom-auto-height">
            <transition :enter-active-class="enterAnimation" :leave-active-class="leaveAnimation" mode="out-in">
                <!--If keep alive-->
                <keep-alive v-if="keepAliveData">
                    <component ref="currentComponent" :is="steps[currentStep.index].component" :is-visible="currentStep.index" :clickedNext="nextButton[currentStep.name]" @can-continue="proceed" @change-next="changeNextBtnValue" :current-step="currentStep"></component>
                </keep-alive>
                <!--If not show component and destroy it in each step change-->
                <component v-else :is="steps[currentStep.index].component" :clickedNext="nextButton[currentStep.name]" @can-continue="proceed" @change-next="changeNextBtnValue" :current-step="currentStep"></component>
            </transition>
        </div>
        <div :class="['bottom', (currentStep.index > 0) ? '' : 'only-next']">
            <div v-if="currentStep.index > 0" class="stepper-button previous" @click="backStep()">
                <i class="material-icons">keyboard_arrow_left</i>
                <span>{{ 'Zurück' }}</span>
            </div>
            <div class="stepper-button">
            <b-button pill variant="primary" :class="['stepper-button']" style="margin-right: 2rem"  @click="cancle()">Abbruch</b-button>
              <b-button v-if="canPrint && finalStep" pill variant="primary" style="margin-right: 1rem" :class="['stepper-button next', !canContinue ? 'deactivated' : '']" :disabled="!canContinue" @click="nextStep(true)">Senden und Drucken</b-button>
              <b-button v-if="hasCadastre && currentStep.name === '2'" pill variant="primary" style="margin-right: 1rem" :class="['stepper-button next']" @click="isCadastre = !isCadastre; $refs.currentComponent.toggleCadastre(isCadastre)">{{isCadastre ? 'Standartansicht' : 'Katasteransicht'}}</b-button>
              <!--b-button v-if="isPlanStep" pill variant="primary" style="margin-right: 1rem" :class="['stepper-button next', !canContinue ? 'deactivated' : '']" :disabled="!canContinue" @click="nextStep(false, 'Auftrag')">Einzelauftrag</b-button>
              <b-button v-if="isPlanStep" pill variant="primary" :class="['stepper-button next', !canContinue ? 'deactivated' : '']" :disabled="!canContinue" @click="nextStep(false, 'Aufgabe')">Aufgabe</b-button-->
              <b-button pill variant="primary" :class="['stepper-button next', !canContinue ? 'deactivated' : '']" :disabled="!canContinue" @click="nextStep()">{{ (finalStep) ? 'Senden' : 'Weiter'}}</b-button>
            </div>
            <!--div :class="['stepper-button next', !canContinue ? 'deactivated' : '']" @click="nextStep()">
                <span>{{ (finalStep) ? 'Senden' : 'Weiter'}}</span>
                <i class="material-icons">keyboard_arrow_right</i>
            </div-->
        </div>
        </b-row>
    </div>
</template>

<script>
    // https://github.com/PygmySlowLoris/vue-stepper
    export default {
        props: {
            locale: {
                type: String,
                default: "en"
            },
            topButtons: {
                type: Boolean,
                default: false
            },
            steps: {
                type: Array,
                default: function() {
                    return [
                        {
                            icon: "mail",
                            name: "first",
                            title: "Sample title 1",
                            subtitle: "Subtitle sample"
                        },
                        {
                            icon: "report_problem",
                            name: "second",
                            title: "Sample title 2",
                            subtitle: "Subtitle sample"
                        }
                    ];
                }
            },
            keepAlive: {
                type: Boolean,
                default: true
            },
            reset: {
                type: Boolean,
                default: false
            },
            canPrint: {
              type: Boolean,
              default: false
            },
            hasCadastre: {
              type: Boolean,
              default: false
            }
        },
        updated() {
        },
        data() {
            return {
                currentStep: {},
                previousStep: {},
                nextButton: {},
                canContinue: false,
                finalStep: false,
                isPlanStep: false,
                keepAliveData: this.keepAlive,
                componentRefs: [undefined, undefined, undefined, undefined],
              isCadastre: false,
            };
        },
        computed: {
            enterAnimation() {
                if (this.currentStep.index < this.previousStep.index) {
                    return "animated quick fadeInLeft";
                } else {
                    return "animated quick fadeInRight";
                }
            },
            leaveAnimation() {
                if (this.currentStep.index > this.previousStep.index) {
                    return "animated quick fadeOutLeft";
                } else {
                    return "animated quick fadeOutRight";
                }
            }
        },
        methods: {
            cancle() {
              this.$router.go(-1);
            },
            isStepActive(index, step) {
                if (this.currentStep.index === index) {
                    return "activated";
                } else {
                    return "deactivated";
                }
            },
            activateStep(index, back = false, taskType) {
                if (this.steps[index]) {
                    this.previousStep = this.currentStep;
                    if (this.$refs.currentComponent !== undefined) {
                        this.currentStep.returnData = this.$refs.currentComponent.getReturnData();
                      if (taskType !== undefined && (taskType === 'Aufgabe' || taskType === 'Auftrag')) {
                        this.currentStep.returnData.acceptTask = taskType;
                      }
                    }
                    if (!back) {
                        this.$emit("completed-step", this.previousStep);
                        if (this.componentRefs[index]) {
                            console.log(this.componentRefs[index]);
                            console.log(this.componentRefs);
                            console.log(index);
                            this.componentRefs[index].setActive(this.steps[index].payload);
                        }
                    } else {
                        this.componentRefs[index+1] = this.$refs.currentComponent;
                    }
                    this.currentStep = {
                        name: this.steps[index].name,
                        index: index,
                        payload: this.steps[index].payload,
                        returnData: {},
                    };
                    console.log(this.currentStep)
                    this.isPlanStep = this.currentStep.name === 'plan_task';
                    if (index + 1 === this.steps.length) {
                        this.finalStep = true;
                    } else {
                        this.finalStep = false;
                    }
                }
                this.$emit("active-step", this.currentStep);
            },
            nextStepAction(print, taskType) {
                this.nextButton[this.currentStep.name] = true;
                if (this.canContinue) {
                    if (this.finalStep) {
                        if (this.$refs.currentComponent !== undefined) {
                            this.currentStep.returnData = this.$refs.currentComponent.getReturnData();
                            this.currentStep.print = print;
                        }
                        this.$emit("stepper-finished", this.currentStep);
                    }
                    let currentIndex = this.currentStep.index + 1;
                    this.activateStep(currentIndex, false, taskType);
                }
                this.$forceUpdate();
                if (this.$refs.currentComponent !== undefined) {
                    //this.$refs.currentComponent.setActive(this.steps[index].payload);
                }
            },
            nextStep (print, taskType) {
                if (!this.$listeners || !this.$listeners['before-next-step']) {
                    this.nextStepAction(print, taskType)
                }
                this.$emit("before-next-step", { currentStep: this.currentStep }, (next = true) => {
                    if (next) {
                        this.nextStepAction(print, taskType)
                    }
                });
            },
            backStep() {
                this.$emit("clicking-back");
                let currentIndex = this.currentStep.index - 1;
                if (currentIndex >= 0) {
                    this.activateStep(currentIndex, true);
                }
                this.canContinue = true;
            },
            proceed(payload) {
                this.canContinue = payload.value;
            },
            changeNextBtnValue(payload) {
                this.nextButton[this.currentStep.name] = payload.nextBtnValue;
                this.$forceUpdate();
            },
            init() {
                // Initiate stepper
                this.activateStep(0);
                this.steps.forEach(step => {
                    this.nextButton[step.name] = false;
                });
            }
        },
        watch: {
            reset(val) {
                if(!val) {
                    return;
                }
                this.keepAliveData = false;
                this.init();
                this.previousStep = {};
                this.$nextTick(() => {
                    this.keepAliveData = this.keepAlive;
                    this.$emit('reset', true);
                });
            }
        },
        created() {
            this.init();
        }
    };
</script>

<style src="./HorizontalStepper.scss" scoped lang="scss">
</style>
<style src="./animate.min.cs.css" scoped lang="css">
</style>
<style scoped>
    /* fallback */
    @font-face {
        font-family: "Material Icons";
        font-style: normal;
        font-weight: 400;
        src: local("Material Icons"), local("MaterialIcons-Regular"),
        url(/fonts/2fcrYFNaTjcS6g4U3t-Y5ZjZjT5FdEJ140U2DJYC3mY.woff2)
        format("woff2");
    }
    .material-icons {
        font-family: "Material Icons";
        font-weight: normal;
        font-style: normal;
        font-size: 24px;
        line-height: 1;
        letter-spacing: normal;
        text-transform: none;
        display: inline-block;
        white-space: nowrap;
        word-wrap: normal;
        direction: ltr;
        -webkit-font-feature-settings: "liga";
        -webkit-font-smoothing: antialiased;
    }
</style>
